import React, { Component } from "react";
import "./FloatingAlert.scss";
import FloatingAlertDisplay from "./FloatingAlert.styled";

export default class FloatingAlert extends Component {
  render() {
    const { type, className } = this.props;
    const alertClassName = [
      type === "success" ? "bg-success" : "",
      className || "",
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <FloatingAlertDisplay type={type} className={alertClassName || undefined}>
        {this.props.children}
      </FloatingAlertDisplay>
    );
  }
}
